module.exports = __webpack_public_path__ + "static/media/closeup-shot-beekeeper-holding-honeycombs-frame-with-many-bees-making-honey.ad9a7305.jpg";